import React, { useCallback, useState } from "react";
import { Checkbox, Modal } from "@shopify/polaris";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";

import { handleError } from "../../../helper";

const SET_DEFAULT_EXPORT_TEMPLATE = gql`
    mutation setDefaultExportTemplate($id: ID!, $isDefault: Boolean!) {
        setDefaultExportTemplate(id: $id, isDefault: $isDefault)
    }
`;

export const ExportTemplateUpdateDefault = ({
    item,
    open,
    toggleShowModal,
    onNotificationChange,
    toggleActive,
    refetch,
}) => {
    const [isDefault, setIsDefault] = useState(!!item.isDefault);

    const [updateTemplate, { loading }] = useMutation(
        SET_DEFAULT_EXPORT_TEMPLATE,
        {
            onCompleted: () => {
                toggleShowModal();
                if (onNotificationChange) {
                    onNotificationChange({
                        message: "Update export template successfuly.",
                        isError: false,
                    });
                }
                if (refetch) {
                    refetch();
                }
            },
            onError: (error) => {
                if (onNotificationChange) {
                    onNotificationChange({
                        message: handleError(error.toString()),
                        isError: true,
                    });
                }
            },
        },
    );

    // Handle actions
    const handleSubmit = useCallback(() => {
        if (onNotificationChange) {
            onNotificationChange({
                message: null,
                isError: false,
            });
        }
        if (item?.id) {
            updateTemplate({
                variables: {
                    id: item?.id,
                    isDefault,
                },
            });
        }
        if (toggleActive) {
            toggleActive();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item?.id, isDefault]);

    return (
        <Modal
            title="Update Export Template"
            open={open}
            onClose={toggleShowModal}
            sectioned
            secondaryActions={[
                { content: "Cancel", onAction: toggleShowModal },
            ]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <Checkbox
                label="Make this the default"
                checked={isDefault}
                onChange={(value) => {
                    console.log("value", value);
                    setIsDefault(value);
                }}
            />
        </Modal>
    );
};
